import VisaIcon from "@/icons/withdraw/visa";
import UsdIcon from "@/icons/withdraw/usd";
import EuroIcon from "@/icons/withdraw/euro";
import MasterCardIcon from "@/icons/withdraw/master";
import GPayIcon from "@/icons/withdraw/gpay";
import AppleIcon from "@/icons/withdraw/apple";

// Define the types
export type CurrencyData = {
  label: string;
  value: string;
  currencyType?: string;
  Icon?: React.ElementType;
};

export type NetworkData = {
  label: string;
  value: string;
  Icon?: React.ElementType;
};

// Define your currency data for each network
export const currenciesByNetwork: { [key: string]: CurrencyData[] } = {
  VISA: [
    {
      label: "USD",
      value: "USD",
      currencyType: "USD",
      Icon: UsdIcon,
    },
    {
      label: "EUR",
      value: "EUR",
      currencyType: "EUR",
      Icon: EuroIcon,
    },
  ],
  MASTER: [
    {
      label: "USD",
      value: "USD",
      currencyType: "USD",
      Icon: UsdIcon,
    },
    {
      label: "EUR",
      value: "EUR",
      currencyType: "EUR",
      Icon: EuroIcon,
    },
  ],
  Google: [
    {
      label: "USD",
      value: "USD",
      currencyType: "USD",
      Icon: UsdIcon,
    },
    {
      label: "EUR",
      value: "EUR",
      currencyType: "EUR",
      Icon: EuroIcon,
    },
  ],
  Apple: [
    {
      label: "USD",
      value: "USD",
      currencyType: "USD",
      Icon: UsdIcon,
    },
    {
      label: "EUR",
      value: "EUR",
      currencyType: "EUR",
      Icon: EuroIcon,
    },
  ],
};

export const networkData: NetworkData[] = [
  {
    label: "VISA CARD",
    value: "VISA",
    Icon: VisaIcon,
  },
  {
    label: "MASTER CARD",
    value: "MASTER",
    Icon: MasterCardIcon,
  },
  {
    label: "Google Pay",
    value: "Google",
    Icon: GPayIcon,
  },
  {
    label: "Apple Pay",
    value: "Apple",
    Icon: AppleIcon,
  },
];
